import { TFunction } from 'i18next';
import { v4 } from 'uuid';
import getCalloutTemplates from 'v1/components/modals/CalloutModals/CalloutCreateModal/CALLOUT_TEMPLATES.js';
import { Callout } from '__types__/v1/models/Callout';

export type CalloutTemplate = {
  id: number;
  name: string;
  description: string;
  template_data: {
    mappings: Array<Omit<NonNullable<Callout['mappings']>[number], 'id'>>;
  };
};

export function getTranslatedCalloutTemplates(
  t: TFunction<'callouts'>
): CalloutTemplate[] {
  return getCalloutTemplates(t);
}

export function buildMappingsFromTemplate(
  template: CalloutTemplate
): NonNullable<Callout['mappings']> {
  return template.template_data.mappings.map(field => ({
    ...field,
    id: v4()
  }));
}

export function cloneCalloutMappings(
  mappings: NonNullable<Callout['mappings']>
): NonNullable<Callout['mappings']> {
  return mappings.map(mapping => ({
    ...mapping,
    id: v4()
  }));
}
